export default (address, country) => {
  const isJpOrCn = country === 'JP' || country === 'CN'; // TODO MYBAG-2430 and MYBAG-2431 this needs to be addressed
  if (isJpOrCn || address?.country !== country) {
    return { country };
  }
  return address;
};
